import React, { useEffect, useState } from 'react';
import { Users, Ticket, ShoppingCart } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
interface UrgencyBannerProps {
  spots: number;
  onSale: () => void;
  viewers: number;
}
export function UrgencyBanner({
  spots,
  onSale,
  viewers
}: UrgencyBannerProps) {
  const [isSticky, setIsSticky] = useState(false);
  const [recentSale, setRecentSale] = useState({
    show: false,
    text: ''
  });
  useEffect(() => {
    const handleScroll = () => {
      const purchaseSection = document.getElementById('purchase');
      if (purchaseSection) {
        const rect = purchaseSection.getBoundingClientRect();
        // Aparece sticky cuando la sección de compra está cerca de entrar o ya entró
        setIsSticky(rect.top <= 100);
      }
    };
    window.addEventListener('scroll', handleScroll);
    const sales = ['1 cupón vendido hace 5 mins', 'Nuevo acceso desde Mendoza hace 2 min', '1 cupón reservado hace instantes'];
    let saleTimeout: NodeJS.Timeout;
    const triggerSale = () => {
      const randomTime = Math.floor(Math.random() * (25000 - 15000 + 1)) + 15000;
      saleTimeout = setTimeout(() => {
        setRecentSale({
          show: true,
          text: sales[Math.floor(Math.random() * sales.length)]
        });
        onSale();
        setTimeout(() => {
          setRecentSale({
            show: false,
            text: ''
          });
        }, 4000);
        triggerSale();
      }, randomTime);
    };
    triggerSale();
    return () => {
      window.removeEventListener('scroll', handleScroll);
      clearTimeout(saleTimeout);
    };
  }, []);
  return <>
      {/* Floating Notification (When NOT sticky) */}
      <AnimatePresence data-id="element-288">
        {!isSticky && recentSale.show && <motion.div initial={{
        opacity: 0,
        x: -50,
        y: 50
      }} animate={{
        opacity: 1,
        x: 0,
        y: 0
      }} exit={{
        opacity: 0,
        x: -50,
        scale: 0.8
      }} className="fixed bottom-6 left-6 z-[60] bg-white text-violet-950 p-4 rounded-2xl shadow-[0_20px_50px_rgba(0,0,0,0.2)] border border-violet-100 flex items-center gap-4 max-w-sm" data-id="element-289">
            <div className="w-10 h-10 bg-violet-100 rounded-full flex items-center justify-center text-violet-600 shrink-0" data-id="element-290">
              <ShoppingCart size={20} data-id="element-291" />
            </div>
            <div data-id="element-292">
              <p className="text-xs font-black text-violet-400 uppercase tracking-widest" data-id="element-293">
                Venta Reciente
              </p>
              <p className="font-bold text-sm leading-tight" data-id="element-294">
                {recentSale.text}
              </p>
            </div>
          </motion.div>}
      </AnimatePresence>

      {/* Sticky Banner */}
      <motion.div initial={false} animate={{
      y: isSticky ? 0 : -100,
      opacity: isSticky ? 1 : 0
    }} className="text-white py-1.5 fixed top-0 left-0 w-full z-50 shadow-lg border-b border-violet-200/20 bg-[#2E1065]/95 backdrop-blur-sm" data-id="element-295">
        <div className="max-container px-4 flex flex-wrap justify-center items-center gap-4 text-xs font-black uppercase tracking-tighter" data-id="element-296">
          <div className="flex text-[12px] font-[600] font-[Poppins,_sans-serif] gap-[6px] flex-row items-center justify-start" data-id="element-297">
            <span className="relative flex h-2 w-2" data-id="element-298">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75" data-id="element-299"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-green-400" data-id="element-300"></span>
            </span>
            <Users size={14} className="text-violet-300" data-id="element-301" />
            {viewers} PERSONAS MIRANDO
          </div>
          <motion.div animate={{
          opacity: [1, 0.7, 1]
        }} transition={{
          duration: 1.5,
          repeat: Infinity,
          ease: 'linear'
        }} className="flex items-center gap-2 font-[600] text-[12px]" data-id="element-302">
            <span className="relative flex h-2 w-2" data-id="element-303">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-500 opacity-75" data-id="element-304"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-red-500" data-id="element-305"></span>
            </span>
            <Ticket size={14} className="text-violet-300" data-id="element-306" />
            CUPOS DISPONIBLES:{' '}
            <motion.span key={spots} initial={{
            scale: 1.4,
            color: '#f87171'
          }} animate={{
            scale: 1,
            color: 'inherit'
          }} transition={{
            duration: 0.4
          }} className="inline-block ml-1" data-id="element-307">
              {spots}
            </motion.span>
          </motion.div>

          {/* Integrated Notification (When sticky) */}
          <AnimatePresence data-id="element-308">
            {isSticky && recentSale.show && <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} animate={{
            opacity: 1,
            scale: 1
          }} exit={{
            opacity: 0,
            scale: 0.9
          }} className="flex items-center gap-2 bg-violet-100 text-violet-950 px-3 py-1 rounded font-bold text-xs" data-id="element-309">
                <ShoppingCart size={14} data-id="element-310" />
                {recentSale.text}
              </motion.div>}
          </AnimatePresence>
        </div>
      </motion.div>
    </>;
}